export enum CertificationStateEnum {
  NONE = 'none',
  IN_PROGRESS = 'progress',
  DONE = 'done',
}
